import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { EstatusJSON } from '../../shared/models/EstatusJSON';
import { DashboardAPIService } from '../../shared/services/API/DashboardAPI.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  mapboxToken: string;
  configUrl: string;
  private isLoading: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();
  
  constructor(private dashboardService : DashboardAPIService) {
  }
  
  
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }


  getResume(): Observable<EstatusJSON> {
    return this.dashboardService.getResume();
  }

  getTableauReports(): Observable<EstatusJSON>{
    return this.dashboardService.getTableauReports();
  }  
}

